import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import 'swiper/css'
import { AchievementsHook } from '../../../hooks/useAchievements'
import { BadgeHook } from '../../../hooks/useBadges'
import { ScoreboardHook } from '../../../hooks/useScoreboard'
import { generateTimePeriods } from '../../../utils/scoreboard/generateTimePeriods'
import ScoreboardDots from './components/ScoreboardDots'
import ScoreboardHeader from './components/ScoreboardHeader'
import ScoreboardSwiper from './components/ScoreboardSwiper'
import { useScoreboardSwiper } from './hooks/useScoreboardSwiper'

interface SwipeableScoreboardGridProps {
	data: ScoreboardHook
	achievementsHook: AchievementsHook
	badgeHook: BadgeHook
}

const SwipeableScoreboardGrid: React.FC<SwipeableScoreboardGridProps> = ({
	data,
	achievementsHook,
	badgeHook,
}) => {
	const { activeSlide, handleDotClick } = useScoreboardSwiper()
	const { t } = useTranslation('pages_saving')
	const timePeriods = useMemo(() => generateTimePeriods(t), [t])

	return (
		<div className='flex flex-col gap-4'>
			<ScoreboardHeader activeSlide={activeSlide} timePeriods={timePeriods} />

			<ScoreboardSwiper
				timePeriods={timePeriods}
				data={data}
				achievementsHook={achievementsHook}
				badgeHook={badgeHook}
			/>

			<ScoreboardDots
				timePeriods={timePeriods}
				activeSlide={activeSlide}
				onDotClick={handleDotClick}
			/>
		</div>
	)
}

export default SwipeableScoreboardGrid
